import {createSelector} from 'reselect';

import {NAME} from './constants';

export const getLabels = state => state[NAME].list;

export const isGridSorting = state => state[NAME].grid.isSorting;

export const arePetLabelsValid = state => state[NAME].petLabelsValid;
export const getPetLabels = state => state[NAME].petLabels;

export const getPetTypes = state => state[NAME].search.petTypes;
export const getSelectedPetTypes = state => state[NAME].search.selectedPetTypes;
export const getSearchResults = state => state[NAME].search.results;
export const getSearchPhrase = state => state[NAME].search.phrase;

export const getSelectedGridIndex = state => state[NAME].selected.gridIndex;

export const areDefinitionsValid = state => state[NAME].definitionsValid;
export const getLabelDefinitions = state => state[NAME].definitions;

export const getActivePageSize = state => state[NAME].activeSize;


export const getSelectedPetLabelId = state => state[NAME].selected.petLabelId;
export const getSelectedArticleMappingId = state => state[NAME].selected.articleMappingId;
export const getActivePetLabel = state => state[NAME].active.petLabel;

export const getCustomDefinitions = state => state[NAME].customDefinitions;
export const getSelectedCustomType = state => state[NAME].selectedCustomType;

export const getPdfId = state => state[NAME].pdfId;

export const getArticles = state => state[NAME].articles;
export const getShownArticles = state => state[NAME].shownArticles;
export const areArticlesValid = state => state[NAME].articlesValid;

export const getStyleElements = state => state[NAME].styleElements;

export const getCalibrationLink = state => state[NAME].calibrationLink;

export const isLabelModalOpen = state => state[NAME].labelModalOpen;
export const isLabelAddEnabled = state => state[NAME].labelAddEnabled;

export const getActiveDefinition = createSelector(
	getLabelDefinitions,
	getActivePageSize,
	(labelDefinitions, activePageSize) => {
		return labelDefinitions.find((definition) => {
			return definition.LabelName === activePageSize;
		});
	}
);

export const getActiveLabelSize = createSelector(
	getActiveDefinition,
	(activeDefinition) => {
		if(!activeDefinition) {
			return {};
		}
		return {
			width: activeDefinition.Width,
			height: activeDefinition.Height
		};
	}
);

export const getActiveLogo = createSelector(
	getActiveDefinition,
	(activeDefinition) => {
		if(!activeDefinition) {
			return '';
		}
		return activeDefinition.LogoUrl;
	}
);

export const getCustomDefinition = createSelector(
	getSelectedCustomType,
	getCustomDefinitions,
	(petType, definitions) => {
		return definitions[petType];
		}
);

export const getFieldPositions = createSelector(
	getActiveDefinition,
	getActivePetLabel,
	(activeDefinition, activePetLabel) => {
		if(!activeDefinition || !activePetLabel) {
			return [];
		}

		return activeDefinition.FieldMappings.filter((mapping) => {
			return mapping.PetType === activePetLabel.PetType;
		});
	}
);

export const getEmptyLabels = createSelector(
	getLabels,
	(labels) => {
		let count = 0;
		labels.forEach((label) => {
			if(Object.keys(label).length === 0)
			{
				count++;
			}
		});
		return count;
	}
);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/selectors.js
 **/